<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import {
    ScrollAreaScrollbar,
    type ScrollAreaScrollbarProps,
    ScrollAreaThumb,
} from "radix-vue";
import { cn } from "@/lib/utils";

const props = withDefaults(
    defineProps<
        ScrollAreaScrollbarProps & { class?: HTMLAttributes["class"] }
    >(),
    {
        orientation: "vertical",
    },
);

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <ScrollAreaScrollbar
        v-bind="delegatedProps"
        :class="
            cn(
                'flex touch-none transition-colors select-none',
                orientation === 'vertical' &&
                    'w-2.5 h-full border-l border-l-transparent p-px',
                orientation === 'horizontal' &&
                    'h-2.5 flex-col border-t border-t-transparent p-px',
                props.class,
            )
        "
    >
        <ScrollAreaThumb
            class="bg-stone-200 dark:bg-stone-800 relative flex-1 rounded-full"
        />
    </ScrollAreaScrollbar>
</template>
